// Web Vitals performance tracking
export function reportWebVitals(metric: any) {
  // Log to console in development
  if (process.env.NODE_ENV === 'development') {
    console.log(metric)
  }

  // Send to analytics in production
  if (process.env.NODE_ENV === 'production') {
    // You can send to your analytics service here
    // Example: Google Analytics
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('event', metric.name, {
        value: Math.round(metric.value),
        event_category: 'Web Vitals',
        event_label: metric.id,
        non_interaction: true,
      })
    }

    // Or send to a custom endpoint
    if (metric.name) {
      const body = JSON.stringify({
        name: metric.name,
        value: metric.value,
        id: metric.id,
        label: metric.label,
        timestamp: new Date().toISOString(),
      })

      // Use sendBeacon for reliability
      if (navigator.sendBeacon) {
        navigator.sendBeacon('/api/metrics', body)
      }
    }
  }
}

// Performance budgets
export const PERFORMANCE_BUDGETS = {
  FCP: 1800, // First Contentful Paint - 1.8s
  LCP: 2500, // Largest Contentful Paint - 2.5s
  FID: 100,  // First Input Delay - 100ms
  CLS: 0.1,  // Cumulative Layout Shift - 0.1
  TTFB: 800, // Time to First Byte - 800ms
}

// Check if metrics meet performance budgets
export function checkPerformanceBudget(metric: any) {
  const budget = PERFORMANCE_BUDGETS[metric.name as keyof typeof PERFORMANCE_BUDGETS]
  
  if (budget && metric.value > budget) {
    console.warn(`⚠️ Performance budget exceeded for ${metric.name}: ${metric.value}ms (budget: ${budget}ms)`)
    
    // You could also send alerts here
    if (process.env.NODE_ENV === 'production') {
      // Send alert to monitoring service
    }
  }
}

// Custom performance marks
export function markPerformance(name: string) {
  if (typeof window !== 'undefined' && window.performance) {
    window.performance.mark(name)
  }
}

// Measure between two marks
export function measurePerformance(name: string, startMark: string, endMark?: string) {
  if (typeof window !== 'undefined' && window.performance) {
    try {
      if (endMark) {
        window.performance.measure(name, startMark, endMark)
      } else {
        window.performance.measure(name, startMark)
      }
      
      const entries = window.performance.getEntriesByName(name, 'measure')
      if (entries.length > 0) {
        const duration = entries[entries.length - 1].duration
        console.log(`⏱️ ${name}: ${duration.toFixed(2)}ms`)
        return duration
      }
    } catch (error) {
      console.error('Performance measurement error:', error)
    }
  }
  return null
}

// Resource timing analysis
export function analyzeResourceTiming() {
  if (typeof window !== 'undefined' && window.performance) {
    const resources = window.performance.getEntriesByType('resource')
    
    // Group by type
    const byType: Record<string, any[]> = {}
    resources.forEach(resource => {
      const type = (resource as any).initiatorType || 'other'
      if (!byType[type]) byType[type] = []
      byType[type].push(resource)
    })
    
    // Calculate stats
    Object.entries(byType).forEach(([type, items]) => {
      const totalDuration = items.reduce((sum, item) => sum + item.duration, 0)
      const avgDuration = totalDuration / items.length
      
      console.log(`📊 ${type}: ${items.length} resources, avg: ${avgDuration.toFixed(2)}ms`)
    })
    
    // Find slow resources
    const slowResources = resources
      .filter(r => r.duration > 1000)
      .sort((a, b) => b.duration - a.duration)
      .slice(0, 5)
    
    if (slowResources.length > 0) {
      console.warn('🐌 Slow resources detected:')
      slowResources.forEach(r => {
        console.warn(`  - ${r.name}: ${r.duration.toFixed(2)}ms`)
      })
    }
  }
}